import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editInactive } from "../features/transaction/transactionSlice";
import {
	changeTransaction,
	createTransaction,
} from "../features/transaction/transactionThunk";

const Form = () => {
	const [name, setName] = useState("");
	const [amount, setAmount] = useState("");
	const [type, setType] = useState("");
	const [editMode, setEditMode] = useState(false);

	const dispatch = useDispatch();
	const { isLoading, isError, editing } = useSelector(
		(state) => state.transaction
	);

	useEffect(() => {
		const {id, name, amount, type} = editing || {};
		if(id) {
			setEditMode(true);
			setName(name);
			setAmount(amount);
			setType(type);
		} else {
			setEditMode(false);
			reset();
		}
	}, [editing])

	const reset = () => {
		setName("");
		setAmount("");
		setType("");
	};

	const handleCreate = (e) => {
		e.preventDefault();

		dispatch(
			createTransaction({
				name,
				type,
				amount: Number(amount),
			})
		);
		reset();
	};

	const handleUpdate = (e) => {
		e.preventDefault();

		dispatch(
			changeTransaction({
				id: editing?.id,
				data: {
					name: name,
					amount: amount,
					type: type,
				},
			})
		);
		setEditMode(false);
		reset();
	};

	const cancelEditMode = () => {
		dispatch(editInactive())
		reset();
		setEditMode(false);
	};

	return (
		<div className="flex justify-center items-center sm:drop-shadow-lg">
			<div className="w-full md:w-2/3 lg:w-1/2 xl:w-2/4 2xl:w-1/3 pt-4 pb-6 px-4 md:px-6 bg-white border space-y-6">
				<h3 className="text-lg sm:text-xl border-b border-b-200 pb-2">
					Add New Transaction
				</h3>

				<form
					onSubmit={editMode ? handleUpdate : handleCreate}
					className="space-y-4 sm:text-lg"
				>
					<div className="flex gap-6 sm:gap-8 justify-between items-center">
						<label htmlFor="">Name</label>
						<input
							type="text"
							name="name"
							required
							value={name}
							onChange={(e) => setName(e.target.value)}
							autoComplete="off"
							placeholder="Enter Transaction Name"
							className="flex-grow w-full focus:border-green-400 focus:ring-400"
						/>
					</div>
					<div className="flex gap-12 justify-between items-center">
						<label htmlFor="">Type</label>
						<div className="flex-grow flex space-x-8">
							<div className="space-x-2">
								<input
									type="radio"
									required
									value="income"
									name="type"
									checked={type === "income"}
									onChange={(e) => setType("income")}
								/>
								<label htmlFor="">Income</label>
							</div>
							<div className="space-x-2">
								<input
									type="radio"
									value="expense"
									name="type"
									checked={type === "expense"}
									onChange={(e) => setType("expense")}
								/>
								<label htmlFor="">Expense</label>
							</div>
						</div>
					</div>
					<div className="flex gap-2 sm:gap-4 pb-4 justify-between items-center">
						<label htmlFor="">Amount</label>
						<input
							type="number"
							required
							name="amount"
							value={amount}
							onChange={(e) => setAmount(e.target.value)}
							placeholder="Enter amount"
							className="flex-grow w-full focus:border-green-400 focus:ring-400"
						/>
					</div>

					<button
						disabled={isLoading}
						type="submit"
						className="w-full items-center py-2 bg-green-800 text-white hover:bg-green-700"
					>
						{editMode ? "Update Transaction" : "Add Transaction"}
					</button>

					{!isLoading && isError && (
						<p className="text-red-400">There was an error occured</p>
					)}
				</form>

				{editMode && (
					<button
						className="w-full items-center py-2 bg-red-800 text-white hover:bg-red-700"
						onClick={cancelEditMode}
					>
						Cancel Edit
					</button>
				)}
			</div>
		</div>
	);
};

export default Form;
